import type { LiveMapMetadata } from "lib/protocols/mapFilterYaml";

/** Stable key for comparing live map grid geometry (bounds sizing). */
export function liveMapGeometryKey(
    meta: LiveMapMetadata | null | undefined,
): string | null {
    if (!meta) return null;
    const { width, height, resolution, origin } = meta;
    if (
        typeof width !== "number" ||
        typeof height !== "number" ||
        typeof resolution !== "number" ||
        !origin ||
        typeof origin.x !== "number" ||
        typeof origin.y !== "number"
    ) {
        return null;
    }
    const yaw = typeof meta.originYaw === "number" ? meta.originYaw : 0;
    return `${width}:${height}:${resolution}:${origin.x}:${origin.y}:${yaw}`;
}

export function isSameLiveMapGeometry(
    a: LiveMapMetadata | null | undefined,
    b: LiveMapMetadata | null | undefined,
): boolean {
    const ka = liveMapGeometryKey(a);
    const kb = liveMapGeometryKey(b);
    return ka != null && ka === kb;
}
